module.exports = __webpack_public_path__ + "img/bipot_bobocoin.gm.2389355.png";